// import React from "react";
import { withRouter } from "react-router";
// import { Link } from "react-router-dom";
import routeMapTable from "../config/routeMapTable";
import PropTypes from "prop-types";
// import config from "../config/config";

const RoutePage = ({ match, history }) => {
    const category = match.params.category;
    const gameid = match.params.gameid;
    const game = routeMapTable[category];

    if (!category || !gameid || !game) {
        history.push("/");
        return null;
    }

    // const startUrl = `${config.flashUrl}/${category}/${gameid}`;
    // const foundCat = game.categories.find(l => {
    //     return l.link.startsWith(startUrl);
    // });

    history.push(`/${category}`);
    return null;
};

RoutePage.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export default withRouter(RoutePage);
